export const DOCUMENT_UPLOAD_TIMEOUT_MS = 5 * 60 * 1000;

export function isDocumentUploadTimedOut(uploadedAt: number | undefined, now: number): boolean {
    // 0 is a valid clock, not missing.
    if (uploadedAt == null) return false;
    return now - uploadedAt >= DOCUMENT_UPLOAD_TIMEOUT_MS;
}
